import LandingWhyPresentation from 'components/LandingWhy/LandingWhyPresentation'

export default {
  Presentation: LandingWhyPresentation,
}
